<!-- SKELETON CARGA INICIAL -->
<div class="cartilla-wrapper cartilla-skeleton" *ngIf="flagCargando">
  <div class="cartilla-container">
    <div class="sk-bar sk-bar--user">
      <div class="sk-avatar"></div>
      <div class="sk-details">
        <div class="skeleton-line sk-name"></div>
        <div class="skeleton-line sk-plan"></div>
      </div>
      <div class="skeleton-line sk-link"></div>
    </div>
    <div class="sk-bar sk-bar--location">
      <div class="sk-avatar"></div>
      <div class="skeleton-line sk-location"></div>
      <div class="skeleton-line sk-link"></div>
    </div>
    <div class="skeleton-line sk-section"></div>
    <div class="rubros-grid">
      <div class="rubro-card skeleton-card" *ngFor="let i of [0,1,2,3,4,5,6,7]">
        <div class="rubro-icon-wrapper">
          <div class="skeleton-line skeleton-icon"></div>
        </div>
        <div class="skeleton-line skeleton-title"></div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="!flagCargando" class="cartilla-wrapper">
  <div class="cartilla-container">

    <!-- BARRA DE USUARIO Y PLAN -->
    <div class="user-bar">
      <mat-icon class="bar-icon bar-icon--primary">account_circle</mat-icon>
      <div class="user-details">
        <span class="user-name">{{ getUserDisplayName() }}</span>
        <span class="user-plan-tag">Plan: {{ planNombre || 'Sin plan' }}</span>
      </div>
      <button class="bar-link" (click)="togglePlanDropdown()">
        {{ usandoPlanPropio ? 'Cambiar' : 'Usar mi plan' }}
      </button>
    </div>

    <!-- DROPDOWN DE PLANES -->
    <div class="dropdown-panel" *ngIf="planDropdownOpen">
      <div class="dropdown-option"
           [class.selected]="usandoPlanPropio"
           (click)="usarMiPlan()">
        Mi plan ({{ planDefaultNombre }})
      </div>
      <div class="dropdown-option"
           *ngFor="let plan of planes"
           [class.selected]="planId === plan._id && !usandoPlanPropio"
           (click)="selectPlan(plan)">
        {{ plan.denominacion }}
      </div>
    </div>

    <!-- BARRA DE UBICACIÓN -->
    <div class="location-bar" *ngIf="locationReady">
      <mat-icon class="bar-icon bar-icon--secondary">location_on</mat-icon>
      <span class="location-text">
        <ng-container *ngIf="!modoManualUbicacion">
          {{ mostrarBotonCercania ? 'Buscando cerca de tu ubicación' : 'Ubicación no disponible' }}
        </ng-container>
        <ng-container *ngIf="modoManualUbicacion">
          {{ getSelectedZonaText() || getSelectedLocalidadText() || 'Seleccione zona y localidad' }}
        </ng-container>
      </span>
      <button class="bar-link" (click)="toggleModoUbicacion()">
        {{ modoManualUbicacion ? 'Usar mi ubicación' : 'Cambiar' }}
      </button>
    </div>

    <!-- PANEL DE UBICACIÓN MANUAL -->
    <div class="ubicacion-panel" *ngIf="modoManualUbicacion">
      <div class="form-field">
        <label class="field-label">Zona</label>
        <div class="custom-select" [class.open]="zonaDropdownOpen">
          <div class="select-display" (click)="toggleZonaDropdown()">
            <span class="selected-text">{{ getSelectedZonaText() || 'Seleccione una zona' }}</span>
            <mat-icon class="dropdown-arrow">expand_more</mat-icon>
          </div>
          <div class="dropdown-options" *ngIf="zonaDropdownOpen">
            <div class="dropdown-option" (click)="selectZona(null)">Ninguno</div>
            <div class="dropdown-option" *ngFor="let zona of zonas"
                 [class.selected]="zonaSeleccionada === zona._id"
                 (click)="selectZona(zona)">
              {{ zona.concepto }}
            </div>
          </div>
        </div>
      </div>
      <div class="form-field">
        <label class="field-label">Localidad</label>
        <div class="custom-select" [class.open]="localidadDropdownOpen">
          <div class="select-display" (click)="toggleLocalidadDropdown()">
            <span class="selected-text">{{ getSelectedLocalidadText() || 'Seleccione una localidad' }}</span>
            <mat-icon class="dropdown-arrow">expand_more</mat-icon>
          </div>
          <div class="dropdown-options" *ngIf="localidadDropdownOpen">
            <div class="dropdown-option" (click)="selectLocalidad(null)">Ninguno</div>
            <div class="dropdown-option" *ngFor="let localidad of localidades"
                 [class.selected]="localidadSeleccionada === localidad._id"
                 (click)="selectLocalidad(localidad)">
              {{ localidad.nombre }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- GRID DE RUBROS -->
    <div class="rubros-section" *ngIf="!mostrandoEspecialidades && !selectedRubro && !selectedEspecialidad && !flagBuscando">
      <h2 class="section-title">Seleccione un rubro para iniciar la búsqueda</h2>
      <div class="rubros-grid">
        <button class="rubro-card" (click)="onEspecialidadesMedicas()">
          <div class="rubro-icon-wrapper">
            <mat-icon class="rubro-icon">medical_services</mat-icon>
          </div>
          <span class="rubro-label">Especialidades Médicas</span>
        </button>
        <button class="rubro-card"
                *ngFor="let rubro of rubros"
                (click)="onRubroTap(rubro)"
                [class.selected]="selectedRubro?._id === rubro._id">
          <div class="rubro-icon-wrapper">
            <mat-icon class="rubro-icon">{{ getIconForRubro(rubro) }}</mat-icon>
          </div>
          <span class="rubro-label">{{ normalizarConcepto(rubro.concepto) }}</span>
        </button>
      </div>
    </div>

    <!-- LISTA DE ESPECIALIDADES -->
    <div class="rubros-section" *ngIf="mostrandoEspecialidades && !selectedEspecialidad && !flagBuscando">
      <div class="section-header">
        <button class="back-link" (click)="volverARubros()">
          <mat-icon>arrow_back</mat-icon>
          <span>Volver a rubros</span>
        </button>
        <h2 class="section-title">Seleccione una especialidad</h2>
      </div>
      <div class="name-filter">
        <mat-icon class="filter-icon">search</mat-icon>
        <input type="text" class="filter-input" placeholder="Buscar especialidad..." [(ngModel)]="filtroEspecialidad">
        <button class="filter-clear" *ngIf="filtroEspecialidad" (click)="filtroEspecialidad = ''">
          <mat-icon>cancel</mat-icon>
        </button>
      </div>
      <div class="especialidades-list">
        <button class="especialidad-item"
                *ngFor="let esp of getEspecialidadesFiltradas()"
                (click)="onEspecialidadTap(esp)">
          <span class="especialidad-name">{{ normalizarConcepto(esp.concepto) }}</span>
          <mat-icon class="especialidad-arrow">chevron_right</mat-icon>
        </button>
      </div>
      <div class="no-results" *ngIf="getEspecialidadesFiltradas().length === 0 && especialidades.length > 0">
        No se encontraron especialidades con "{{ filtroEspecialidad }}".
      </div>
    </div>

    <!-- RESULTADOS -->
    <div class="results-section cartilla-skeleton" *ngIf="flagBuscando && (selectedRubro || selectedEspecialidad)">
      <div class="results-card">
        <div class="results-header">
          <div class="header-top">
            <span class="sk-buscando">Buscando...</span>
          </div>
        </div>
        <div class="results-list">
          <div class="result-item sk-result" *ngFor="let i of [0,1,2,3,4]">
            <div class="item-info">
              <div class="skeleton-line sk-name"></div>
              <div class="skeleton-line sk-address"></div>
              <div class="skeleton-line sk-address sk-address--short"></div>
              <div class="skeleton-line sk-extra"></div>
              <div class="skeleton-line sk-extra sk-extra--short"></div>
            </div>
            <div class="item-actions sk-actions">
              <div class="skeleton-line sk-btn"></div>
              <div class="skeleton-line sk-btn"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="results-section" id="resultados"
         *ngIf="!flagBuscando && (selectedRubro || selectedEspecialidad) && (totalCentrosSinFiltro > 0 || sinResultados)">
      <div class="results-card">
        <div class="results-header">
          <div class="header-top">
            <h3 class="results-title">{{ normalizarConcepto(selectedRubro?.concepto || selectedEspecialidad?.concepto || '') }}</h3>
            <button class="close-results" (click)="volverDesdeResultados()">
              <mat-icon>arrow_back</mat-icon>
              <span>Volver</span>
            </button>
          </div>
          <p class="results-count" *ngIf="totalCentrosSinFiltro > 0">
            {{ totalCentrosMostrados === totalCentrosSinFiltro
               ? 'Centros encontrados: ' + totalCentrosMostrados
               : 'Mostrando ' + totalCentrosMostrados + ' de ' + totalCentrosSinFiltro + ' centros' }}
          </p>
          <small class="results-hint" *ngIf="totalCentrosMostrados > 0">Haga click en la sede para ver en mapa</small>
        </div>

        <div class="name-filter" *ngIf="totalCentrosSinFiltro > 0">
          <mat-icon class="filter-icon">search</mat-icon>
          <input type="text" class="filter-input" placeholder="Filtrar por nombre, calle o zona..."
                 [(ngModel)]="filtroNombre" (input)="onFiltroNombreChange()">
          <button class="filter-clear" *ngIf="filtroNombre" (click)="filtroNombre = ''; onFiltroNombreChange()">
            <mat-icon>cancel</mat-icon>
          </button>
        </div>

        <div class="aviso-cercania" *ngIf="sinResultadosCercania && totalCentrosMostrados > 0">
          No se encontraron centros cercanos a tu ubicación. Se muestran otras opciones disponibles.
        </div>
        <div class="aviso-cercania" *ngIf="mostrandoCentroMasLejano">
          No hay centros cerca de tu ubicación. Te mostramos el más cercano.
        </div>
        <div class="aviso-cercania" *ngIf="mostrandoFallbackManual && totalCentrosMostrados > 0">
          {{ mensajeFallbackManual }}
        </div>

        <div class="results-list" *ngIf="!modoManualUbicacion && resultadosCentrosCercanos.length > 0">
          <div class="result-item" *ngFor="let centro of resultadosCentrosCercanos" (click)="openMap(centro)">
            <div class="item-info">
              <h4 class="center-name">
                {{ centro.nombre }}
                <span class="distance-badge" *ngIf="getDistanciaCentro(centro)">{{ getDistanciaCentro(centro) }}</span>
              </h4>
              <p class="center-address" *ngIf="centro.zona?.concepto || centro.localidad?.nombre">
                {{ centro.zona?.concepto }} - {{ centro.localidad?.nombre }}
              </p>
              <p class="center-address">{{ centro.calle }} {{ centro.altura }}</p>
              <p class="center-extra" *ngIf="getConcepto(centro.rubros)">
                {{ getConcepto(centro.rubros) }}
                <ng-container *ngIf="getConcepto(centro.especialidades)">
                  · {{ getConcepto(centro.especialidades) }}
                </ng-container>
              </p>
              <p class="center-extra" *ngIf="centro.horarios && centro.horarios !== 'Basico'">
                {{ centro.horarios }}
              </p>
            </div>
            <div class="item-actions">
              <button class="action-button" (click)="$event.stopPropagation(); telCentro(centro)" title="Llamar">
                <mat-icon>call</mat-icon>
              </button>
              <button class="action-button" (click)="$event.stopPropagation(); openMap(centro)" title="Ver en mapa">
                <mat-icon>location_on</mat-icon>
              </button>
            </div>
          </div>
        </div>

        <div class="otros-centros-divider" *ngIf="!modoManualUbicacion && resultadosCentrosCercanos.length > 0 && resultadosCentrosLejanos.length > 0">
          <span class="divider-text">Otros centros cercanos</span>
        </div>

        <div class="results-list" *ngIf="!modoManualUbicacion && resultadosCentrosLejanos.length > 0">
          <div class="result-item lejano" *ngFor="let centro of resultadosCentrosLejanos" (click)="openMap(centro)">
            <div class="item-info">
              <h4 class="center-name">
                {{ centro.nombre }}
                <span class="distance-badge" *ngIf="getDistanciaCentro(centro)">{{ getDistanciaCentro(centro) }}</span>
              </h4>
              <p class="center-address" *ngIf="centro.zona?.concepto || centro.localidad?.nombre">
                {{ centro.zona?.concepto }} - {{ centro.localidad?.nombre }}
              </p>
              <p class="center-address">{{ centro.calle }} {{ centro.altura }}</p>
              <p class="center-extra" *ngIf="getConcepto(centro.rubros)">
                {{ getConcepto(centro.rubros) }}
                <ng-container *ngIf="getConcepto(centro.especialidades)">
                  · {{ getConcepto(centro.especialidades) }}
                </ng-container>
              </p>
              <p class="center-extra" *ngIf="centro.horarios && centro.horarios !== 'Basico'">
                {{ centro.horarios }}
              </p>
            </div>
            <div class="item-actions">
              <button class="action-button" (click)="$event.stopPropagation(); telCentro(centro)" title="Llamar">
                <mat-icon>call</mat-icon>
              </button>
              <button class="action-button" (click)="$event.stopPropagation(); openMap(centro)" title="Ver en mapa">
                <mat-icon>location_on</mat-icon>
              </button>
            </div>
          </div>
        </div>

        <!-- CARD MANUAL (reutilizable, sin badge de distancia) -->
        <ng-template #manualCard let-centro>
          <div class="result-item" (click)="openMap(centro)">
            <div class="item-info">
              <h4 class="center-name">{{ centro.nombre }}</h4>
              <p class="center-address" *ngIf="centro.zona?.concepto || centro.localidad?.nombre">
                {{ centro.zona?.concepto }} - {{ centro.localidad?.nombre }}
              </p>
              <p class="center-address">{{ centro.calle }} {{ centro.altura }}</p>
              <p class="center-extra" *ngIf="getConcepto(centro.rubros)">
                {{ getConcepto(centro.rubros) }}
                <ng-container *ngIf="getConcepto(centro.especialidades)">
                  · {{ getConcepto(centro.especialidades) }}
                </ng-container>
              </p>
              <p class="center-extra" *ngIf="centro.horarios && centro.horarios !== 'Basico'">
                {{ centro.horarios }}
              </p>
            </div>
            <div class="item-actions">
              <button class="action-button" (click)="$event.stopPropagation(); telCentro(centro)" title="Llamar">
                <mat-icon>call</mat-icon>
              </button>
              <button class="action-button" (click)="$event.stopPropagation(); openMap(centro)" title="Ver en mapa">
                <mat-icon>location_on</mat-icon>
              </button>
            </div>
          </div>
        </ng-template>

        <!-- RESULTADOS MANUALES: SIN LABELS (zona+localidad) -->
        <ng-container *ngIf="modoManualUbicacion && modoAgrupadoManual === 'ninguno'">
          <div class="results-list">
            <ng-container *ngFor="let centro of resultadosCentrosCercanos">
              <ng-container *ngTemplateOutlet="manualCard; context: { $implicit: centro }"></ng-container>
            </ng-container>
          </div>
        </ng-container>

        <!-- RESULTADOS MANUALES: AGRUPADO POR ZONA/LOCALIDAD CON LABELS -->
        <ng-container *ngIf="modoManualUbicacion && modoAgrupadoManual !== 'ninguno'">
          <div class="zona-group" *ngFor="let grupo of gruposManuales">
            <div class="zona-group-label">{{ grupo.titulo }}</div>
            <div class="results-list">
              <ng-container *ngFor="let centro of grupo.centros">
                <ng-container *ngTemplateOutlet="manualCard; context: { $implicit: centro }"></ng-container>
              </ng-container>
            </div>
          </div>
        </ng-container>

        <div class="no-results" *ngIf="totalCentrosMostrados === 0 && totalCentrosSinFiltro > 0">
          No se encontraron centros con el nombre "{{ filtroNombre }}". Intentá con otro término.
        </div>
        <div class="no-results" *ngIf="sinResultados && !sinResultadosCercania">
          No se encontraron centros para {{ normalizarConcepto(selectedRubro?.concepto || selectedEspecialidad?.concepto || '') }}<ng-container *ngIf="!modoManualUbicacion"> cerca de tu ubicación</ng-container>.
        </div>
        <div class="no-results" *ngIf="sinResultadosCercania && totalCentrosSinFiltro === 0">
          No se encontraron centros cercanos a tu ubicación. Intentá con búsqueda manual.
        </div>
      </div>
    </div>

  </div>
</div>

<!-- MODAL DE TELÉFONOS -->
<div class="phone-modal-overlay" *ngIf="showPhoneModal">
  <div class="phone-modal-content">
    <div class="modal-header">
      <h2 class="modal-title">Contactar {{ centerNameForModal }}</h2>
      <button class="modal-close-button" (click)="closePhoneModal()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div class="modal-body">
      <p class="modal-intro-text" *ngIf="phoneNumbersForModal.length > 1">Selecciona un número para llamar:</p>
      <p class="modal-intro-text" *ngIf="phoneNumbersForModal.length === 0">No se encontraron números de contacto para este centro.</p>
      <ul class="modal-phone-list" *ngIf="phoneNumbersForModal.length > 0">
        <li *ngFor="let numberInfo of phoneNumbersForModal" (click)="handlePhoneNumberAction(numberInfo)">
          <mat-icon>{{ numberInfo.type === 'phone' ? 'call' : 'chat' }}</mat-icon>
          <span class="phone-number">{{ numberInfo.number }}</span>
        </li>
      </ul>
    </div>
  </div>
</div>
